import { ProtocolMode, PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: `${import.meta.env.VITE_CLIENT_ID}`,
        authority: 'https://newscorp.okta.com/oauth2/default',
        redirectUri: '/',
        knownAuthorities: ['https://newscorp.okta.com/oauth2/default'],
        protocolMode: ProtocolMode.OIDC
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    }
};

const initMsalInstance = new PublicClientApplication(msalConfig);
await initMsalInstance.initialize();

export const msalInstance = initMsalInstance;

export const palmScopes = ['openid', 'profile'];

export const loginRequest = {
    scopes: palmScopes,
};

export const rolesPath = '/users/me/roles';

export const featureConfig = import.meta.env.VITE_FEATURE_CONFIGURATION ? JSON.parse(import.meta.env.VITE_FEATURE_CONFIGURATION) : {};

export const oemTenantId = import.meta.env.VITE_OEM_TENANT_ID;
